"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _BasicList = _interopRequireDefault(require("../../elements/List/BasicList/BasicList"));
var _excluded = ["copy"],
  _excluded2 = ["node"];
var MarkdownList = function MarkdownList(_ref) {
  var copy = _ref.copy,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var storeTextColor = props.bfTextColor;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactMarkdown.default, {
    children: copy,
    components: {
      ul: function ul(_ref2) {
        var node = _ref2.node,
          props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
        return _react.default.createElement(_BasicList.default, Object.assign({
          bfTextColor: storeTextColor
        }, props));
      }
    }
  }));
};
var _default = MarkdownList;
exports.default = _default;